import { Component, Input, OnInit } from '@angular/core';
import { IMidtermExamPayment } from '../../models/MidtermExamPayment';

import { AppService } from '../../services/app.service';
import { MidtermExamPaymentService } from '../../services/midterm-exam-payment.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { setNextPaymentValues } from './add.component';

@Component({
    selector: 'app-midterm-exam-payment-details',
    templateUrl: './details.component.html'
})
export class MidtermExamPaymentDetailsComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: MidtermExamPaymentService,
        private modal: NgbActiveModal
    ) { }

    @Input() set id(value: number) {
        this.app.addLoading(this.service.getById(value)).subscribe(data => {
            this.data = data;
        });
    }

    data: IMidtermExamPayment;
    canAdd: boolean;

    ngOnInit() {
        this.canAdd = this.app.currentUser.hasRight('MIDTERM_EXAM_PAYMENT.EDIT');
    }

    add() {
        setNextPaymentValues({
            courseId: this.data.CourseId,
            teacherId: this.data.TeacherId,
            reason: this.data.Reason,
            studentUpn: this.data.StudentUpn,
            studentFullName: this.data.StudentFullName
        });
        this.modal.dismiss();
        this.app.navigateByUrl('/midterm-exam-payments/add');
    }

    close() {
        this.modal.close(this.data);
    }
}
